import PropTypes from 'prop-types';
import Flux from '../../flux/Flux';
import LogoLoader from '../Loader/LogoLoader';
import FeedPostWrapper from './FeedPostWrapper';
import { isRecommended } from './FeedHelper';
import VXButtonOutline from '../SimpleElements/VXButton/Presets/VXButtonOutline';
import { VXButtonLineConfig } from '../SimpleElements/VXButton/VXButtonConfig';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import { addPreventScrolling, generateKey, removePreventScrolling } from '../../utils/CommonUtils';
import { ModalBoxEnum, openModalBox } from '../ModalBox/ModalBoxFactory';
import Translations from '../../utils/Translations';
import FeedLoginSignup from './FeedLoginSignup';
import { PureComponent } from 'react';

const POSTS_PER_PAGE = 10;
const AUTO_LOAD_PAGES = 4; // +1
const URL_POST_ID = 'postid';
let loadMoreTriggerCount = 0;
let _scrollY = null;
let _showLoginModal = false;
let _closeModalboxFn;

class FeedPostList extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			data: this.getStoredPosts(),
			imageId: '',
			isLoading: this.getStoredPosts().length < 1,
			useLoadMoreBtn: false,
			hasNextPage: Flux.Feed.getHasNextPage(this.props.feedType) || false,
			overlayType: '',
			urlParamPostId: this.props.actorId && this.geturlParamPostId(), //only on modelprofile
			isPostPushed: false,
		};

		this.onLoadMore = this.onLoadMore.bind(this);
		this.updatePostById = this.updatePostById.bind(this);
		this.setPosts = this.setPosts.bind(this);
		this.onOverlayChange = this.onOverlayChange.bind(this);
		this.onWindowPopStateChange = this.onWindowPopStateChange.bind(this);
		this.showAll = this.showAll.bind(this);

		this.postListRef;

		this.observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					const onClose = () => {
						window.scrollTo({
							top: _scrollY,
						});
						_scrollY = null;
						setTimeout(() => {
							_showLoginModal = false;
						}, 500);
					};

					if (!Flux.Guest.isLoggedIn() && !_showLoginModal) {
						_showLoginModal = true;
						_scrollY = window.scrollY;
						_closeModalboxFn = openModalBox(ModalBoxEnum.FEED_SIGNUP, {}, onClose);
					}
				}
			},
			{ threshold: 1.0, rootMargin: '0px 0px -100px 0px' },
		);
	}

	componentDidMount() {
		this.state.data.length === 0 && this.getData(this.props.typeGroups, null, true);
		Flux.Feed.addOverlayChangeListener(this.onOverlayChange);
		Flux.Feed.addUpdatePostChangeListener(this.updatePostById);
		Flux.Feed.addSetPostsChangeListener(this.setPosts);
		Flux.Feed.setPosts([], this.props.feedType, false);
		if (this.props.feedType !== Flux.Constants.Feed.FeedType.PROFILE) {
			this.removeurlParamPostId();
		}
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(this.props.typeGroups) !== JSON.stringify(prevProps.typeGroups) ||
			JSON.stringify(this.props.filter) !== JSON.stringify(prevProps.filter)
		) {
			_scrollY = null;
			this.setState({ isLoading: true, data: [] }, () => {
				this.getData(this.props.typeGroups);
			});
		}
	}

	componentWillUnmount() {
		if (!this.state.overlayType) {
			_scrollY = null;
		}
		Flux.Feed.removeOverlayChangeListener(this.onOverlayChange);
		Flux.Feed.removeUpdatePostChangeListener(this.updatePostById);
		Flux.Feed.removeSetPostsChangeListener(this.setPosts);
		if (_closeModalboxFn) {
			_closeModalboxFn();
		}
	}

	getStoredPosts() {
		return Flux.Feed.getPosts(this.props.feedType);
	}

	onWindowPopStateChange() {
		if (this.state.overlayType) {
			Flux.Feed.toggleOverlay(this.state.selectedPostId, '', true);
		}
	}

	geturlParamPostId() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const postId = urlParams.get(URL_POST_ID);
		if (!this.props.actorId && postId) {
			this.removeUrlParamPostId();
			return null;
		}
		return postId;
	}

	seturlParamPostId(postid) {
		const url = new URL(window.location.href);
		const params = url.searchParams;
		params.set(URL_POST_ID, postid);
		window.history.replaceState(window.history.state, '', '?' + params.toString());
	}

	removeurlParamPostId() {
		const urlParamss = new URLSearchParams(window.location.search);
		if (urlParamss.get(URL_POST_ID)) {
			const urlParams = new URL(window.location.href);
			urlParams.searchParams.delete(URL_POST_ID);
			window.history.replaceState(window.history.state, '', urlParams.toString());
		}
	}

	setLoginRef(ref) {
		if (ref) {
			this.observer.observe(ref);
		}
	}

	isSinglePostShow() {
		return this.props.isMobile || (Flux.Browser.isTablet() && !Flux.Browser.isLandscape());
	}

	onOverlayChange(selectedPostId, overlayType, isPopState = false) {
		if (!this.state.overlayType) {
			_scrollY = window.scrollY;

			const newState = {
				overlayType,
				selectedPostId,
			};

			if (!this.isSinglePostShow()) {
				newState.urlParamPostId = selectedPostId;
				this.seturlParamPostId(selectedPostId);
			}

			this.setState({ ...newState }, () => {
				this.addPreventScrolling();
			});
			if (this.props.isMobile) {
				this.setPosts();
				history.pushState({}, '', window.location.href);
				window.addEventListener('popstate', this.onWindowPopStateChange);
			}
		} else {
			this.removePreventScrolling();
			setTimeout(() => {
				_scrollY &&
					window.scrollTo({
						top: _scrollY,
					});
				if (!this.props.isMobile) {
					_scrollY = 0;
				}
			}, 0);

			const newState = {
				overlayType: '',
				selectedPostId: null,
			};

			if (!this.isSinglePostShow() && this.state.urlParamPostId) {
				this.removeurlParamPostId();
				let data = [...this.state.data];
				if (this.state.isPostPushed) {
					data = data.filter((item) => item.node.id !== this.state.urlParamPostId);
					newState.isPostPushed = false;
				}
				newState.data = data;
				newState.urlParamPostId = '';
			}

			this.setState({ ...newState }, () => {
				if (history.state && this.props.isMobile) {
					if (!isPopState) {
						history.back();
					}
					Flux.Feed.setPosts([], this.props.feedType, false);
					setTimeout(() => {
						_scrollY = 0;
						window.removeEventListener('popstate', this.onWindowPopStateChange);
					}, 500);
				}
			});
		}
	}

	addPreventScrolling() {
		if (
			!this.props.isMobile ||
			(this.props.isMobile && this.state.overlayType && this.state.overlayType !== Flux.Constants.Feed.OverlayTypes.COMMENTS)
		) {
			const wrapper = document.getElementById('mobile-content-wrapper');
			if (this.props.isMobile && wrapper) {
				wrapper.style.zIndex = '103';
			} else {
				addPreventScrolling();
			}
		}
	}

	removePreventScrolling() {
		const wrapper = document.getElementById('mobile-content-wrapper');
		if (wrapper) {
			wrapper.style.zIndex = '100';
		}
		removePreventScrolling();
	}

	isProfile() {
		return this.props.actorId && this.props.feedType === Flux.Constants.Feed.FeedType.PROFILE;
	}

	getData(typeGroups, after = null, isInit = false) {
		const paramPostId = this.state.urlParamPostId;
		// get single post for mobile permalink
		if (paramPostId && this.isSinglePostShow()) {
			this.getPostById(paramPostId, true);
		} else {
			const args = {
				modelId: this.props.actorId ? this.props.actorId.toString() : null,
				first: POSTS_PER_PAGE,
				after: after,
				typeGroups: typeGroups,
				follows: this.props.filter && this.props.filter.favorites ? true : null,
				bought: this.props.filter && this.props.filter.bought ? true : null,
				liked: this.props.filter && this.props.filter.liked ? true : null,
				commented: this.props.filter && this.props.filter.commented ? true : null,
				mode: this.props.feedType === Flux.Constants.Feed.FeedType.PROFILE ? Flux.Constants.Feed.Mode.MODEL : Flux.Constants.Feed.Mode.MIXED,
			};

			//            if (VXConfig.isOfficeIp && this.props.filter.favorites) {
			//                args.mode = Flux.Constants.Feed.Mode.USER_RECOMMENDATIONS;
			//                args.follows = null;
			//            }

			Flux.Feed.getFeedData(
				{ ...args },
				(res) => {
					const posts = res.data.feed.posts;
					const hasNextPage = posts.pageInfo.hasNextPage;
					const feed = posts.edges;
					const data = isInit ? [...feed] : [...this.state.data, ...feed];

					this.setState({ data, isLoading: false, hasNextPage }, () => {
						_scrollY &&
							window.scrollTo({
								top: _scrollY,
							});
						if (paramPostId) {
							const hasPost = this.state.data.find((item) => item.node.id === paramPostId);
							if (hasPost) {
								Flux.Feed.toggleOverlay(paramPostId, Flux.Constants.Feed.OverlayTypes.ALL);
							} else {
								this.getPostById(paramPostId);
							}
						}
					});
					if (this.isProfile() && res.data.total) {
						this.props.setTotalCount(res.data.total.totalCount);
					}
				},
				this.isProfile(),
			);
		}
	}

	getPostById(postId, isSinglePostShow = false) {
		Flux.Feed.getFeedPost(postId, (response) => {
			if (response.data) {
				const post = response.data.post;
				// post doesnt exist or from other model, show normal feed
				if (!post || post.model.id !== this.props.actorId.toString()) {
					if (isSinglePostShow) {
						this.removeurlParamPostId();
						this.setState({ urlParamPostId: '' }, () => {
							this.getData(this.props.typeGroups);
						});
					}
					return;
				}
				const data = [...this.state.data];
				data.push({ node: post });
				this.setState({ data, isLoading: false, isPostPushed: true }, () => {
					!isSinglePostShow && Flux.Feed.toggleOverlay(post.id, Flux.Constants.Feed.OverlayTypes.ALL);
				});
			}
		});
	}

	updatePostById(id) {
		Flux.Feed.getFeedPost(id, (response) => {
			if (response.data) {
				const post = response.data.post;
				const data = [...this.state.data];

				data.map((item) => {
					if (item.node.id === post.id) {
						item.node = post;
					}
				});
				this.setState({ data });
			}
		});
	}

	setPosts() {
		Flux.Feed.setPosts(this.state.data, this.props.feedType, this.state.hasNextPage);
	}

	loadMore() {
		if (!Flux.Guest.isLoggedIn() || this.state.useLoadMoreBtn) {
			return;
		}

		if (this.state.hasNextPage && !this.state.isLoading) {
			loadMoreTriggerCount += 1;
			this.onLoadMore();
		}
	}

	onLoadMore() {
		if (this.state.data && this.state.data.length > 0 && !this.state.isLoading) {
			const useLoadMoreBtn = loadMoreTriggerCount >= AUTO_LOAD_PAGES;
			if (useLoadMoreBtn) {
				loadMoreTriggerCount = 0;
			}
			this.setState({ isLoading: true, useLoadMoreBtn }, () => {
				this.getData(this.props.typeGroups, this.state.data[this.state.data.length - 1].cursor);
			});
		}
	}

	showAll() {
		window.scrollTo(0, 0);
		this.removeurlParamPostId();
		this.setState({ urlParamPostId: '' }, () => {
			this.getData(this.props.typeGroups, null, true);
		});
	}

	render() {
		const hasData = this.state.data.length > 0;
		//        if (!hasData && VXConfig.isOfficeIp && this.props.filter.favorites) {
		//            return <div className='feed__headline' ref={ref => this.postListRef = ref}>Hupps, hier gibt es noch nichts zu sehen. Like, Kommentiere und Tippe fleissig Inhalte, sodass wir dir hier deine persönlichen Empfehlungen anzeigen können.</div>;
		//        }
		return (
			<div className="feed-list" ref={(ref) => (this.postListRef = ref)}>
				{hasData &&
					this.state.data.map((item, index) => (
						<FeedPostWrapper
							{...this.props}
							{...item.node}
							imageId={this.state.imageId}
							key={generateKey(item.node.id, index)}
							isRecommended={isRecommended(item.node.type)}
							initFavorite={this.props.initFavorite}
						/>
					))}
				{hasData && this.state.useLoadMoreBtn && this.state.hasNextPage && (
					<div className="h-flex -content-center">
						<VXButtonOutline
							staticMode={true}
							line1={[new VXButtonLineConfig(getCommonTranslation('load-more'))]}
							onClick={this.onLoadMore}
						/>
					</div>
				)}
				{this.isSinglePostShow() && this.state.urlParamPostId && (
					<div className="h-flex -content-center">
						<VXButtonOutline
							staticMode={true}
							line1={[new VXButtonLineConfig(getCommonTranslation('show-all'))]}
							onClick={this.showAll}
						/>
					</div>
				)}
				{this.state.isLoading && (
					<div className={'feed__loader' + (this.state.data.length > 0 ? ' feed__loader--small' : '')}>
						<LogoLoader pulse />
					</div>
				)}
				{hasData && !Flux.Guest.isLoggedIn() && this.props.feedType === Flux.Constants.Feed.FeedType.MIXED && (
					<div className={'h-flex -content-center'} ref={(ref) => this.setLoginRef(ref)}>
						{this.props.isMobile && (
							<FeedLoginSignup
								loginText={[new VXButtonLineConfig(Translations.get('NavbarLabelLogin'))]}
								signupText={[new VXButtonLineConfig(Translations.get('NavbarLabelSignup'))]}
							/>
						)}
					</div>
				)}
			</div>
		);
	}
}

FeedPostList.propTypes = {
	typeGroups: PropTypes.array,
	isMobile: PropTypes.bool.isRequired,
	setTotalCount: PropTypes.func.isRequired,
	feedType: PropTypes.string.isRequired,
	actorId: PropTypes.number,
	initFavorite: PropTypes.bool,
	filter: PropTypes.object,
};

FeedPostList.defaultProps = {
	actorId: null,
	initFavorite: false,
	filter: {},
};

export default FeedPostList;
